import React from 'react'
import { Form } from 'react-bootstrap'

const InputField = (props) => {
  const   {label,type,placeholder,text ,id,errorinfo,name,style,register ,as} = props;
 var error = undefined;
  if(errorinfo){
  error = errorinfo[name] && errorinfo[name].message;}
 var input =    <Form.Control {...register(name)} type={type?type:"text"} placeholder={placeholder?placeholder:""} name={name} isInvalid={error!==undefined} style={style?style:{}} />
 if(as){
  input =   <Form.Control {...register(name)} type={type?type:"text"} placeholder={placeholder?placeholder:""} name={name} isInvalid={error!==undefined} style={style?style:{}} as={as}/>
 }

    return (
      <>
        <Form.Group className="mb-3" controlId={id}>
        <Form.Label>{label?label:""}</Form.Label>
        {input}
        <Form.Text className="text-muted">
         {text?text:""}
        </Form.Text>
        <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
      </Form.Group>
      </>
    )
}

export default InputField
